module.exports = __webpack_public_path__ + "static/media/twitter.75b4b6a1.png";